export default {
    init() {
        setupAnchorTags();
    }
}

function setupAnchorTags() {
    scrollToAnchor();
}

function scrollToAnchor() {
    let $headerHeight = $('#header').outerHeight() + 75;

    $('a.anchor-tag[href^="#"]').on('click', function(e){
        e.preventDefault();
        let href = $(this).attr('href');
        $('html, body').animate({
            scrollTop:$(href).offset().top - $headerHeight
        },'slow');
    });
}

